module.exports = __webpack_public_path__ + "ce78c15.webp";